<div class="backround">
  <ng-lottie [options]="options" [styles]="styles"> </ng-lottie>
</div>
